<div [hidden]="visibilityStep(attribute.key)">

  <nav class="wizard-container">
    <ul>
      <li *ngFor="let policy of policies" [class]="getPosition(policy.key)">
        <a class="btnSelectStep" (click)="selectStep(policy.key)">
          <i class="fa"></i>
          <span>
           {{policy.key}}
          </span>
        </a>
        <hr/>
      </li>
    </ul>
  </nav>

  <div class="form-process">
    <div class="form-process-container">
      <app-dynamic *ngFor="let item of attribute.attributes"
        [class]="getSizeClass(item)"
        [attribute]="item"
        (onEmit)="dynamicOnEmit($event)" >
      </app-dynamic>
    </div>
  </div>

    <div class="button-tasks">
        <button *ngIf="isAdmin" class="btn-rasc btn"
          (click)="onDelete()">
          <span>
            <span>
              Excluir cadastro
            </span>
          </span>
        </button>
        <button class="btn-rasc btn btnContinueLater" data-wizard-action="next"
          (click)="onContinueLater()">
          <span>
            <span>
              Continuar depois
            </span>
          </span>
        </button>
        <button *ngIf="!shouldShowFinishButton" class="btn btn-primary btnContinue"
          data-wizard-action="next" (click)="onContinue(attribute.key)">
          <span>
            <span>
              Continuar
            </span>
            &nbsp;&nbsp;
            <i class="fa fa-arrow-right"></i>
          </span>
        </button>
        <ng-container *ngIf="shouldShowFinishButton">
          <button *ngFor="let t of getTasksAndActions()" class="btn btn-primary btnFinish"
            (click)="onExecute(t)">
            <span>
              <span>
                {{ t.key }}
              </span>
              &nbsp;&nbsp;
              <i class="fa fa-arrow-right"></i>
            </span>
          </button>
          <button *ngIf="getTasksAndActions().length === 0" class="btn btn-primary btnFinish" data-wizard-action="next"
            (click)="onExecute(getTask())">
            <span>
              <span>
                {{ getTaskName() }}
              </span>
              &nbsp;&nbsp;
              <i class="fa fa-arrow-right"></i>
            </span>
          </button>
        </ng-container>
    </div>
</div>
